import React from "react"

import BilledSessions from "~Tutor/components/Sessions/BilledSessions"
import ScheduledSessions from "~Tutor/components/Sessions/ScheduledSessions"
import UnbilledSessions from "~Tutor/components/Sessions/UnbilledSessions"

const Sessions = () => {
  return (
    <>
      <UnbilledSessions />
      <ScheduledSessions />
      <BilledSessions />
    </>
  )
}

export default Sessions
